import React, { useState, useCallback } from 'react';
import animateScrollTo from 'animated-scroll-to';
import { SeoHeader, SeoImage } from './Seo';
const logo = require('./assets/images/logo.png');

/**
 * Header Component (Optimized)
 * - Converted from class to functional component
 * - Uses useState for menu toggle state
 * - Uses useCallback for scroll handler optimization
 */
const Header = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = useCallback(() => {
        setIsOpen(prevState => !prevState);
    }, []);

    const scrollTo = useCallback((e, selector) => {
        e.preventDefault();
        animateScrollTo(document.querySelector(selector), { offset: -85 });
    }, []);

    const navbarClass = isOpen ? 'navbar-collapse' : 'collapse navbar-collapse';

    return (
        <header className="row fixed-top ">
            <div className="col-sm-5 col-lg-3 col-md-3 logo_bg">
                <a className="navbar-brand" href="index.html">
                    <SeoImage src={logo} />
                    <SeoHeader />
                </a>
                <button onClick={toggleMenu} className="Button" />
            </div>
                <div className="col-sm-7 col-lg-9 col-md-9">
                <div className="contact-txt">
                    <div className="top_contact">
                        <div className="contct_box">
                            <span>Contact :-</span>&nbsp;
                            <a href="tel:+919925870037">+91 99258 70037</a>&nbsp; | &nbsp;
                            <a href="tel:+919978780452">+91 99787 80452</a>&nbsp; | &nbsp;
                            <a href="tel:+919825847589">+91 98258 47589</a>
                        </div>
                        <div className="social_icon">
                            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HotelChitrakutVirpur/">
                                <i className="fa fa-facebook-square"></i>
                            </a>
                            <a href="/" rel="noopener noreferrer">
                                <i className="fa fa-google-plus-square"></i>
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/hotel_chitrakut_jalaram?igsh=bHVuNTVhY2JhazU1">
                                <i className="fa fa-instagram"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <nav className="navbar navbar-expand-lg">
                    <div className={navbarClass} id="navbarResponsive">

                        <ul className="navbar-nav ml-auto">
                            <li>
                                <div className="d-lg-none d-md-none m-contact"><span> Contact :- </span> <a href="tel:+919925870037">+91 99258 70037</a>&nbsp;  <br/> | &nbsp;<a href="tel:+919978780452">+91 99787 80452</a>&nbsp; | &nbsp;<a href="tel:+919825847589">+91 98258 47589</a></div>
                            </li>
                            <li className="nav-item">
                                <a href="/" className="nav-link" onClick={() => animateScrollTo(0)}>home</a>
                            </li>
                            <li className="nav-item">
                                <a href="/" className="nav-link" onClick={(e) => scrollTo(e, '#aboutUs')}>about us</a>
                            </li>
                            <li className="nav-item">
                                <a href="/" className="nav-link" onClick={(e) => scrollTo(e, '#rooms')}>room</a>
                            </li>
                            <li className="nav-item">
                                <a href="/" className="nav-link" onClick={(e) => scrollTo(e, '#amenities')}>AMENITIES</a>
                            </li>
                            <li className="nav-item">
                                <a href="/" className="nav-link" onClick={(e) => scrollTo(e, '#gallery')}>Gallery</a>
                            </li>
                            <li className="nav-item">
                                <a href="/" className="nav-link" onClick={(e) => scrollTo(e, '#attractions')}>Attractions</a>
                            </li>
                            <li className="nav-item">
                                <a href="/" className="nav-link" onClick={(e) => scrollTo(e, '#contactUs')}>contact us</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
